import {Component, ComponentRef, OnInit} from '@angular/core';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';

import {MODALIDADES} from '../../_mocks/modalidades';
import {COMISSOES} from '../../_mocks/comissoes';
import {ORGAOS} from '../../_mocks/orgaos';
import {TIPO_DE_DOCUMENTOS} from '../../_mocks/tipoDeDocumentos';
import {FASES_DA_LICITACAO} from '../../_mocks/fasesDaLicitacao';
import {TIPOS_DE_OBJETO_DA_LICITACAO} from '../../_mocks/tiposDeObjetoDaLicitacao';

import {Licitacao} from '../../_classes/licitacao';

import {LicitacaoService} from '../../services/licitacao.service';
import {Base64Service} from '../../services/base64.service';
import {Arquivo} from '../../_classes/arquivo';
import {LoadingService} from '../../services/loading.service';
import {FormControl} from '@angular/forms';

import {ActivatedRoute, Router} from '@angular/router';
import {LoadingFileService} from '../../services/loading-file.service';
import {DialogComponent} from '../dialog/dialog.component';
import {MatDialog} from '@angular/material';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import {DomService} from '../../services/dom-service.service';
import {ContratoInfoComponent} from '../contrato/contrato-info/contrato-info.component';

@Component({
  selector: 'app-licitacao-edit',
  templateUrl: './licitacao-edit.component.html',
  styleUrls: ['./licitacao-edit.component.scss'],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS}
  ]
})
export class LicitacaoEditComponent implements OnInit {

  load = false;
  tipoDeDocumento = '';
  required: boolean;
  arquivos: Arquivo[];
  public maskLicitacao = [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public numberMask = createNumberMask({
    prefix: 'R$ ',
    thousandsSeparatorSymbol: '.',
    decimalSymbol: ',',
    decimalLimit: 2,
    allowDecimal: true,
    suffix: ''
  });
  file: File = null;
  licitacao: Licitacao;
  modalidades = MODALIDADES;
  comissoes = COMISSOES;
  orgaos = ORGAOS;
  tipoDeDocumentos = TIPO_DE_DOCUMENTOS;
  fasesDaLicitacao = FASES_DA_LICITACAO;
  tiposDeObjetoDaLicitacao = TIPOS_DE_OBJETO_DA_LICITACAO;

  constructor(
    private adapter: DateAdapter<any>,
    private licitacaoService: LicitacaoService,
    private base64: Base64Service,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private router: Router,
    private loadingFileService: LoadingFileService,
    public dialog: MatDialog,
    private domService: DomService) {

  }

  ngOnInit() {
    this.loadingService.currentLoading.subscribe(load => {
      this.load = load;
    });
    this.initLicitacao();
    this.required = true;
  }

  initLicitacao() {
    this.loadingService.changeLoading(true);
    const id = this.getIdLicitacao();
    this.licitacaoService.getLicitacaoByIdConvertingDates(id)
      .subscribe(result => {
        this.licitacao = result;
        this.arquivos = result.arquivos;
        this.loadingService.changeLoading(false);
      });
  }

  private getIdLicitacao() {
    return +this.route.snapshot.paramMap.get('id');
  }

  handleFileInput(files: FileList, inputFile: FormControl) {
    this.file = files.item(0);
    if (this.file !== undefined && this.file !== null) {
      this.createArquivo(this.file);
      this.file = null;
      inputFile = new FormControl();
      this.tipoDeDocumento = '';
    }
  }

  createArquivo(file: File,) {
    const a = new Arquivo();
    a.extensao = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
    a.nome = file.name;
    a.tamanho = this.getSize(file.size);
    a.tipoDeDocumento = this.tipoDeDocumento;
    this.base64.convert(file, function (result) {
      a.valor = result;
    });
    this.addFile(a);
  }

  addFile(file: Arquivo) {
    if (this.verifyFileIsAdd(file)) {
      alert('Arquivo já adicionado');
    } else if (this.verifySize(file)) {
      alert('Arquivo excede 30 Mb');
    } else {
      this.arquivos.push(file);
    }
  }

  private verifySize(file) {
    if (file.tamanho.indexOf('MB') > -1) {
      return file.tamanho.replace(' MB', '') > 30;
    }
    return false;
  }

  private verifyFileIsAdd(file: Arquivo) {
    let result = false;
    if (this.arquivos.length > 0) {
      this.arquivos.forEach(f => {
        if (file.nome === f.nome) {
          result = true;
          return;
        }
      });
    }

    return result;
  }

  removeFile(file) {
    this.arquivos.splice(this.arquivos.indexOf(file), 1);
  }

  getSize(size: number) {
    size = size / 1000;
    if (999 > size) {
      return size.toFixed(3) + ' Kb';
    }
    size = size / 1000;
    return size.toFixed(3) + ' MB';
  }

  validateFiles() {
    return this.arquivos.length > 0;
  }

  openErrorDialog() {
    this.dialog.open(DialogComponent, {
      width: '300px',
      data: {content: 'Edição cancelada. Já existe uma licitação com essas características registrada!', title: 'Atenção'},
    });
  }

  openSuccessDialog() {
    this.dialog.open(DialogComponent, {
      width: '300px',
      data: {content: 'Edição concluída!', title: 'Sucesso'},
    });
  }

  editarLicitacao(formLicitacao) {
    this.loadingService.changeLoading(true);
    this.loadingFileService.changeLoading(true);
    this.licitacao.arquivos = this.arquivos;
    this.licitacaoService.editLicitacao(this.licitacao.id, this.licitacao).subscribe(response => {
      this.openSuccessDialog();
      this.loadingService.changeLoading(false);
      this.loadingFileService.changeLoading(false);

      this.router.navigate(['/dashboard/licitacao/list']);
    }, error => {
      this.openErrorDialog();
      this.loadingService.changeLoading(false);
      this.loadingFileService.changeLoading(false);
    });
  }

  acaoDocumentoPersonalizado(arquivo: Arquivo) {
    const contratoRef: ComponentRef<ContratoInfoComponent> = this.domService.appendComponentToBody(ContratoInfoComponent);
    contratoRef.instance.contrato = arquivo;
    contratoRef.instance.selfReference = contratoRef;
  }

  excluir() {
    const confirmed = confirm('Você deseja realmente excluir essa licitação?');
    if (confirmed) {
      this.loadingService.changeLoading(true);
      this.licitacaoService.deleteLicitacao(this.licitacao.id).subscribe(result => {
        this.loadingService.changeLoading(false);
        this.router.navigate(['/dashboard/licitacao/list']);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/licitacao-edit/licitacao-edit.component.ts